import styled from 'styled-components';
import { homeHeader_1 } from '../../../../assets/png';
import { homeHeader_2 } from '../../../../assets/png';
import { InnowiseLogo } from '../../../../assets/svg';
import { COLORS, device, FONTS } from '../../../../constants';
import { Text } from '../../../../components';
import {
  MotionHomeHeaderBottomLogo,
  MotionHomeHeaderLeftImage,
  MotionHomeHeaderRightImage,
  MotionHomeHeaderTopBlock,
} from '../../../../components/Motion';

const HeaderLogo = () => {
  return (
    <HeaderLogoWrapper>
      <HeaderImage1 draggable={false} src={homeHeader_1} alt="home header image 1" />
      <HeaderImage2 draggable={false} src={homeHeader_2} alt="home header image 2" />

      <MobileDepartmentText>
        <Text text={'Mobile Development'} fontFamily={FONTS.SUBTITLE} />
      </MobileDepartmentText>

      <LogoWrapper size={243} lgSize={120} bsmSize={80} smSize={120}>
        <InnowiseLogo width={250} height={210} color={'transparent'} />
      </LogoWrapper>

      <CircleSmall size={86} lgSize={40} bsmSize={26} smSize={40} />
      <CircleBig size={500} lgSize={250} bsmSize={170} smSize={250} leftOffset={45}/>
    </HeaderLogoWrapper>
  );
};

const HeaderLogoWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  width: 600px;
  aspect-ratio: 1 / 1;
  flex-shrink: 0;
  flex-grow: 0;

  @media screen and (${device.lg}) {
    width: 300px;
    height: 310px;
  }
  @media screen and (${device.bsm}) {
    width: 200px;
    height: 210px;
  }
  @media screen and (${device.sm}) {
    width: 300px;
    height: 310px;
  }
`;

const HeaderImage1 = styled(MotionHomeHeaderLeftImage)`
  width: 45.4%;
  height: 258px;
  position: absolute;
  z-index: 7;
  left: 0;
  top: 87px;
  @media screen and (${device.lg}) {
    height: 120px;
    top: 40px;
  }
  @media screen and (${device.bsm}) {
    height: 80px;
    top: 25px;
  }
  @media screen and (${device.sm}) {
    height: 120px;
    top: 40px;
  }
`;

const HeaderImage2 = styled(MotionHomeHeaderRightImage)`
  width: 50.8%;
  height: 360px;
  position: absolute;
  z-index: 7;
  right: 0;
  top: 200px;
  @media screen and (${device.lg}) {
    height: 180px;
    top: 100px;
  }
  @media screen and (${device.bsm}) {
    height: 120px;
    top: 66px;
  }
  @media screen and (${device.sm}) {
    height: 180px;
    top: 100px;
  }
`;

const MobileDepartmentText = styled(MotionHomeHeaderTopBlock)`
  width: 217px;
  height: 104px;

  display: flex;
  justify-content: center;
  align-items: center;
  background: ${COLORS.STEP_RED_BORDER};
  position: absolute;
  z-index: 9;
  left: 223px;
  top: 56px;
  h4 {
    color: ${COLORS.WHITE};
    font-weight: 600;
    font-size: 24px;
    text-align: center;
  }
  @media screen and (${device.lg}) {
    width: 100px;
    height: 50px;
    left: 110px;
    top: 26px;
    h4 {
      font-size: 14px;
      line-height: 20px;
      padding: 5px;
    }
  }
  @media screen and (${device.bsm}) {
    width: 70px;
    height: 35px;
    left: 70px;
    top: 16px;
    h4 {
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      padding: 10px;
    }
  }
  @media screen and (${device.sm}) {
    width: 100px;
    height: 50px;
    left: 110px;
    top: 26px;
    h4 {
      font-size: 14px;
      line-height: 20px;
      padding: 5px;
    }
  }
`;

const CircleSmall = styled(MotionHomeHeaderBottomLogo)`
  position: absolute;
  left: 400px;
  top: 0;

  @media screen and (${device.lg}) {
    left: 200px;
  }
  @media screen and (${device.bsm}) {
    left: 130px;
  }
  @media screen and (${device.sm}) {
    left: 200px;
  }
`;

const CircleBig = styled(MotionHomeHeaderBottomLogo)``;

const LogoWrapper = styled(MotionHomeHeaderBottomLogo)`
  position: absolute;
  display: flex;
  align-items: center;
  padding-bottom: 14px;
  box-sizing: border-box;
  justify-content: center;
  z-index: 5;
  left: 10px;
  bottom: 0;

  @media screen and (${device.lg}) {
    svg {
      width: 90px;
    }
  }
  @media screen and (${device.bsm}) {
    svg {
      width: 65px;
    }
  }
  @media screen and (${device.sm}) {
    svg {
      width: 90px;
    }
  }
`;

export default HeaderLogo;
